module.exports = __webpack_public_path__ + "static/media/icon_apple.793d989a.svg";